export enum RR_TABLE_PAGINATION_POSITION {
  TOP,
  BOTTOM,
  TOP_AND_BOTTOM,
  NONE,
}
